import React from 'react'
import Dialog from '@material-ui/core/Dialog'
import Slide from '@material-ui/core/Slide'
import TermsAndCondition from './TemsAndCondition'

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
})

class TermsAndConditionModal extends React.Component {
    state = {
        open: false
    }

    openModal = () => this.setState({ open: true })

    closeModal = () => this.setState({ open: false })

    render() {
        return (
            <Dialog style={{ maxWidth: 700, margin: '0 auto' }} fullScreen open={this.state.open} TransitionComponent={Transition}>
                <TermsAndCondition onClose={this.closeModal} />
            </Dialog>
        )
    }
}

export default TermsAndConditionModal
